import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { Header } from "./Header";
import { ImpersonationBanner } from "./ImpersonationBanner";
import { Sidebar } from "./Sidebar";

/**
 * App shell: fixed sidebar on the left, sticky header on top of content,
 * scrollable main region. Page content renders into the Outlet and is
 * responsible for its own page-header (title + actions).
 */
export function AppShell() {
  const location = useLocation();
  const isChat = location.pathname === "/";

  return (
    <div className="flex h-dvh overflow-hidden bg-background">
      <Sidebar />
      {/* min-w-0 is critical: without it, a flex item (this column) grows to
          fit wide children (tables, long URLs) and pushes the viewport wider
          than the device screen. With it, wide children must scroll inside
          their own containers, not the page body. */}
      <div className="relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <ImpersonationBanner />
        <Header />
        <main className={isChat ? "min-h-0 min-w-0 flex-1 overflow-hidden" : "min-h-0 min-w-0 flex-1 overflow-y-auto"}>
          <div className={isChat ? "h-full min-w-0" : "mx-auto min-w-0 max-w-[1480px] p-4 sm:p-6 lg:p-8 xl:p-10"}>
            <Suspense fallback={<PageFallback />}>
              <Outlet />
            </Suspense>
          </div>
        </main>
      </div>
    </div>
  );
}

function PageFallback() {
  return (
    <div className="space-y-5" role="status" aria-label="Загрузка раздела">
      <div className="h-8 w-52 animate-pulse rounded-xl bg-muted" />
      <div className="h-4 w-80 max-w-full animate-pulse rounded bg-muted/70" />
      <div className="h-64 animate-pulse rounded-3xl border bg-card/80" />
    </div>
  );
}
